import { Spinner } from "@material-tailwind/react";

/**
 * @description
 * SpinnerWithMessageLoader Component:
 * This component displays a spinner along with an optional loading message.
 * It is often used to indicate that content is being loaded.
 *
 * @param {object} props - Props for the SpinnerWithMessageLoader component.
 * @param {string} props.message - Optional message to display alongside the spinner.
 * @param {string} props.className - Additional CSS class names for styling.
 */
interface ISpinnerWithMessageLoaderProps {
  message?: string;
  className?: string;
  height?: string;
  width?: string;
}

/**
 * @description
 * Functional component that renders a spinner with an optional loading message.
 *
 * @param {object} props - Props for the SpinnerWithMessageLoader component.
 * @param {string} props.message - Optional message to display alongside the spinner.
 * @param {string} props.className - Additional CSS class names for styling.
 */
export const SpinnerWithMessageLoader = ({
  message,
  className,
  height,
  width,
}: ISpinnerWithMessageLoaderProps) => {
  return (
    <div className="flex flex-col items-center justify-center text-center m-auto gap-8 "
      style={{
        height: `${height ? height : "100vh"}`,
        width: `${width ? width : "100vh"}`,
      }}
    >
      {/* Display a spinning icon */}
      <Spinner fontSize={"20px"} style={{ height: "3rem", width: "3rem" }} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />

      {/* Display a loading message, using the provided message or a default one */}
      <section>
        {message ? <p>{message} ...</p> : <p>Chargement ...</p>}
      </section>
    </div>
  );
};
